import axiosInstance from "@/lib/axios"

export interface ServiceApp {
    id: number
    owner_id: number
    name: string
    description: string | null
    callback_uri: string
    client_id: string
    is_active: boolean
    created_at: string
    updated_at: string | null
}

export interface ServiceAppWithSecret extends ServiceApp {
    client_secret: string
}

export interface ServiceAppCreate {
    name: string
    description?: string
    callback_uri: string
}

export interface ServiceAppUpdate {
    name?: string
    description?: string
    callback_uri?: string
    is_active?: boolean
}

export interface SSOInitiateResponse {
    callback_url: string
    session_key: string
    expires_in: number
}

const serviceAppsService = {
    create: async (data: ServiceAppCreate): Promise<ServiceAppWithSecret> => {
        const res = await axiosInstance.post<ServiceAppWithSecret>("/service-apps/", data)
        return res.data
    },

    list: async (): Promise<ServiceApp[]> => {
        const res = await axiosInstance.get<ServiceApp[]>("/service-apps/")
        return res.data
    },

    get: async (id: number): Promise<ServiceApp> => {
        const res = await axiosInstance.get<ServiceApp>(`/service-apps/${id}`)
        return res.data
    },

    update: async (id: number, data: ServiceAppUpdate): Promise<ServiceApp> => {
        const res = await axiosInstance.put<ServiceApp>(`/service-apps/${id}`, data)
        return res.data
    },

    delete: async (id: number): Promise<void> => {
        await axiosInstance.delete(`/service-apps/${id}`)
    },

    regenerateSecret: async (id: number): Promise<ServiceAppWithSecret> => {
        const res = await axiosInstance.post<ServiceAppWithSecret>(`/service-apps/${id}/regenerate-secret`)
        return res.data
    },

    getSessionStats: async (): Promise<Record<string, number>> => {
        const res = await axiosInstance.get<Record<string, number>>("/service-apps/stats/sessions")
        return res.data
    },

    initiateSession: async (clientId: string, destination: string): Promise<SSOInitiateResponse> => {
        const res = await axiosInstance.get<SSOInitiateResponse>("/service-apps/auth/initiate", {
            params: { client_id: clientId, destination },
        })
        return res.data
    },

    lookupByName: async (name: string): Promise<{ name: string; client_id: string }> => {
        const res = await axiosInstance.get<{ name: string; client_id: string }>("/service-apps/public/lookup", {
            params: { name },
        })
        return res.data
    },
}

export default serviceAppsService
